<template>
  <div class="container">
    <Head v-if="meta.title" v-bind:meta="meta"></Head>
    <Header></Header>
    <Navigation></Navigation>
    <Breadcrumbs
      v-if="breadcrumbs"
      v-bind:breadcrumbs="breadcrumbs"
    ></Breadcrumbs>
    <BiogramContent :biogram="biogram"></BiogramContent>
    <BiogramRelated
      v-if="total"
      :item="item"
      :total="total"
      :slides="slides"
    ></BiogramRelated>

    <Footer></Footer>
  </div>
</template>

<script>
// libraries
import Vivus from "vivus";
import axios from "axios";
import NProgress from "nprogress";

// components

import Head from "@/components/Common/Head.vue";
import Header from "@/components/Header/Header.vue";
import BiogramContent from "@/components/Biogram/BiogramContent.vue";
import Navigation from "@/components/Common/Navigation.vue";
import Footer from "@/components/Footer/Footer.vue";
import Breadcrumbs from "@/components/Common/Breadcrumbs.vue";
import BiogramRelated from "@/components/Biogram/BiogramRelated.vue";

// https://fizykoteka.ckc.uw.edu.pl/omeka/api/items?item_type=FizykotekaBiogram

// functions

export default {
  name: "Biogram",
  props: ["apiCall"],
  components: {
    Head,
    Header,
    Navigation,
    BiogramContent,
    BiogramRelated,
    Breadcrumbs,
    Footer,
  },
  data() {
    return {
      fbShareURL:
        "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href,
      meta: {
        url: window.location.href,
        description: "",
        title: "",
        og_type: "website",
        og_image: "",
      },
      more_meta: null,
      breadcrumbs: {
        parent_title: "Biogramy",
        parent_uri: "/biogramy",
        self_title: "",
        self_uri: window.location.href,
      },
      item: null,
      biogram: null,
      related: null,
      tags: null,
      slides: null,
      total: null,
    };
  },
  methods: {
    pareseBiogram() {
      // check if proper item type

      if (this.item.item_type.id != 18) {
        this.$router.push({
          name: "NotFound",
        });
      }

      // let's build a biogram object

      //console.log(this.item);

      this.biogram = {
        metadata: null,
        name: null,
        description: null,
        birth_year: null,
        death_year: null,
        portrait: null,
        tags: this.item.tags,
      };

      // try to get portrait

      axios
        .get(this.$config.API_PATH + "files?item=" + this.$route.params.id)
        .then((_img) => {
          this.biogram.portrait = require("@/assets/img/blank_portrait.jpg");
          //this.biogram.portrait = "@/assets/img/blank_portrait.jpg";

          if (_img.data.length != 0) {
            this.biogram.portrait = _img.data[0].file_urls.fullsize;
          }

          let _metadata = this.item.element_texts;

          if (_metadata.find((x) => x.element.id == "52")) {
            this.biogram.name = this.name = _metadata.find(
              (x) => x.element.id == "52"
            ).text;
          }

          // get dates & description
          this.biogram.description = _metadata.find((x) => x.element.id == "61").text

          if (_metadata.find((x) => x.element.id == "53"))
            this.biogram.birth_year = _metadata
              .find((x) => x.element.id == "53")
              .text.slice(0, 4);
          if (_metadata.find((x) => x.element.id == "54"))
            this.biogram.death_year = _metadata
              .find((x) => x.element.id == "54")
              .text.slice(0, 4);

          // // build some meta

          //console.log(this.biogram.description.split(';')[0])
          // fix me pls
          // image as encode - nie!

          this.$route.params.biogram_title = this.biogram.name;

          this.meta = {
            title: this.biogram.name + " - Fizykoteka",
            description: this.biogram.description.slice(".")[0],
            og_type: "website",
            og_image: this.biogram.portrait,
            url: window.location.href,
          };

          // parse metadata

          let _item_metadata = [];
          let _carieer = [];

          _metadata.forEach((_e) => {
            let _remove = [41, 46, 50, 61, 64, 65, 63];
            let _filter = [43, 64, 65, 66];

            let _hide = false;

            if (_filter.includes(_e.element.id)) {
              _hide = true;
            }

            if (!_remove.includes(_e.element.id)) {
              // uri to link

              _e.text = _e.text.replace(
                /((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g,
                '<a href="$1" style="color: #c63;" target="_blank">$1</a> '
              );

              _e.text = _e.text.trim();

              //if (null && _e.element.id == "59" || null && _e.element.id == "58") {
              if (null) {
                // generating links for searching

                let _f = _e.text.split("|");

                if (_f.length > 1) {
                  let _d = [];

                  _f.forEach((_fe) => {
                    _fe =
                      '<a href="' +
                      document.location.origin +
                      "/szukaj/" +
                      _fe.trim() +
                      '" style="color: #c63;">' +
                      _fe.trim() +
                      "</a>";
                    _d.push(_fe);
                  });

                  _e.text = _d.join(" &#x2012; ");
                } else if (null) {
                  _e.text = _e.text.toString();
                  _e.text =
                    '<a href="' +
                    document.location.origin +
                    "/szukaj/" +
                    _e.text.trim() +
                    '" style="color: #c63;">' +
                    _e.text.trim() +
                    "</a>";
                }
              }

              // common fields
              // item_metadata moze byc puste

              if (_e.element.id == 70) {
                // add to 40 (if exists)
                // put dates in range (40,70)

                let _m = _item_metadata.find((x) => x.field_id == 40);
                // remove html in a bad way
                _m.value = _m.value
                  .split("<li>")
                  .join("")
                  .split("</li>")
                  .join("");
                _m.value = "<li>" + _m.value + " - " + _e.text + "</li>";
              } else {
                let _order;
                let _self = this;
                axios
                  .get(this.$config.API_PATH + "elements/" + _e.element.id)
                  .then(function (_el) {
                    if (
                      _item_metadata.find((x) => x.field_id == _e.element.id)
                    ) {
                      let _m = _item_metadata.find(
                        (x) => x.field_id == _e.element.id
                      );
                      _m.value = _m.value + "<li>" + _e.text + "</li>";

                      // order in 58
                      if (_e.element.id == 58) {
                        //let _b = _m.value;
                        let _b = _e.text.split(" | ");
                        _carieer.push({
                          year: Number(_b[0]),
                          position: _b[1],
                          institution: _b[2],
                        });

                        _carieer.sort(
                          (a, b) => parseFloat(a.year) - parseFloat(b.year)
                        );

                        _m.value = "";

                        _carieer.forEach((_t) => {
                          if (typeof _t.institution === "undefined") {
                            _m.value =
                              _m.value +
                              "<li>" +
                              _t.year +
                              " | " +
                              _t.position +
                              "</li>";
                          } else {
                            _m.value =
                              _m.value +
                              "<li>" +
                              _t.year +
                              " | " +
                              _t.position +
                              " | " +
                              _t.institution +
                              "</li>";
                          }
                        });
                      }
                    } else {
                      _order = _el.data.order;

                      //console.log("order: " + _order + " element_id: " + _e.element.id)

                      if (!_order) _order = 9999999999999

                      if (_e.element.id == 58) {
                        //let _b = _m.value;

                        // for the first value
                        let _b = _e.text.split(" | ");
                        _carieer.push({
                          year: Number(_b[0]),
                          position: _b[1],
                          institution: _b[2],
                        });
                      }

                      if (_self.more_meta === null && _hide === true)
                        _self.more_meta = true;

                      let _m = {
                        field_id: _e.element.id,
                        field_name: _e.element.name_translated,
                        value: "<li>" + _e.text + "</li>",
                        order: _order,
                        hide: _hide,
                      };

                      _item_metadata.push(_m);
                      _item_metadata.sort(
                        (a, b) => parseFloat(a.order) - parseFloat(b.order)
                      );
                      _self.biogram.metadata = _item_metadata;
                    }
                  }).finally(() => {
                    _item_metadata.sort(
                        (a, b) => parseFloat(a.order) - parseFloat(b.order)
                      );
                    console.log(_item_metadata)  
                  });
              }
            }
          });
        });
    },
    checkRelated() {
      // check related

      let _rp =
        this.$config.API_PATH +
        "items?advanced[0][joiner]=and&advanced[0][element_id]=46&advanced[0][type]=is+exactly&advanced[0][terms]=" +
        this.$route.params.id +
        "&item_type=20";
      let _rd =
        this.$config.API_PATH +
        "items?advanced[0][joiner]=and&advanced[0][element_id]=46&advanced[0][type]=is+exactly&advanced[0][terms]=" +
        this.$route.params.id +
        "&item_type=19";
      let _rs =
        this.$config.API_PATH +
        "items?advanced[0][joiner]=and&advanced[0][element_id]=46&advanced[0][type]=is+exactly&advanced[0][terms]=" +
        this.$route.params.id +
        "&item_type=24";

      axios
        .all([axios.get(_rp), axios.get(_rd), axios.get(_rs)])
        .then(
          axios.spread((..._resp) => {
            this.related = _resp;
            this.parseRelated();
          })
        )
        .catch((errors) => {});
    },
    fetchData() {
      NProgress.start();
      axios
        .get(this.$config.API_PATH + this.apiCall + "/" + this.$route.params.id)
        .then((_resp) => {
          if (_resp.length == 0) {
            this.$router.push({
              name: "NotFound",
            });
          }

          this.item = _resp.data;
          this.pareseBiogram();
          this.checkRelated();
        })
        .then(() => {
          NProgress.done();
          //console.log(this.biogram);
        })
        .catch((error) => {
          /* this.$router.push({
              name: "NotFound",
            }); */
          //console.log(error);
        });
    },
    generatePaths(id) {
      // id = item.item_type.id
      if (id == 20) return "/fotografia";
      if (id == 19) return "/dokument";
      if (id == 24) return "/eksponat";
    },
    parseRelated() {
      // get only first pages of each type

      this.total =
        Number(this.related[0].headers["omeka-total-results"]) +
        Number(this.related[1].headers["omeka-total-results"]) +
        Number(this.related[2].headers["omeka-total-results"]);

      if (this.related) {
        let _arr = [];

        //console.log(this.related)

        _arr = _arr.concat(
          this.related[0].data,
          this.related[1].data,
          this.related[2].data
        );

        this.slides = [];

        _arr.forEach((_item) => {
          // don't need biograms
          if (_item.item_type.id != "18") {
            // get titles

            let _title = "Brak tytułu";

            if (_item.element_texts.find((x) => x.element.id == "50"))
              _title = _item.element_texts.find(
                (x) => x.element.id == "50"
              ).text;

            axios
              .get(this.$config.API_PATH + "files?item=" + _item.id)
              .then((_img) => {
                this.slides.push({
                  id: _item.id,
                  title: _title,
                  file_urls: _img.data[0].file_urls,
                  type: _item.item_type.id,
                  path: this.generatePaths(_item.item_type.id),
                });
              });
          }
        });
      }
    },
  },
  destroyed() {},
  mounted: function () {},
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData",
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Biogram/Biogram.vue